// extracted by mini-css-extract-plugin
export default {"pinkbtn":"Nav_pinkbtn__-2pZ7","navEdit":"Nav_navEdit__yujnJ","linkHover":"Nav_linkHover__Z1jQy","offCanvasResponsiveMobile":"Nav_offCanvasResponsiveMobile__AG1lP"};